
<template>
<!-- 1031日，弃用table标签，考试选项水平对其和缩进效果基本实现 -->
<!-- tab选项栏基本实现flex布局，但是最后一行如何达到靠左的效果？ -->

  <div id="exam" @click="RunOnBeforeUnload()">
    <div class="timeKiller">
      <img src="@/assets/timer.jpg" alt="">
      <span>
        倒计时 &nbsp;&nbsp;
        <div class="time m-l-10" style="display:inline;">
            <span>0</span>
            <span>0</span>
            <span>:</span>
            <span>0</span>
            <span>0</span>
            <span>:</span>
            <span>0</span>
            <span>0</span>
        </div>
      </span>
     
    </div>

    <div class="main">
      <div class="show_wrap">
        <div class="qtShow">
          <p class="qts">
            {{current.index+1}}、{{current.name}}
          </p>
          <div class="options" v-for="(item,i) in current.itme" :key="i">
            <p @click="moni(item.id)">
              <input type="checkbox" v-model="item.select" :id="item.id" :ref="item.id" @change="select(item)">
              <label class="label" :for="item.id" @click="moni(item.id)" ></label>
              {{item.order}}&nbsp;{{item.option}}
            </p>
          </div>


          <button @click="next(current.id)">下一题</button>
        </div>
      </div>

      <span class="iconfont icon-tiaoxuanxiangmu iconShow" @click="tabShow=!tabShow"></span>
      <div class="qtsTab_wrap" v-show="tabShow">
        <div class="qtsTab">
          <div class="categery">
            <div>
              <span class="current"></span>当前
            </div>
            <div>
              <span class="done"></span>已做
            </div>
            <div>
              <span class="not_done"></span>未做
            </div>
          </div>
          <div class="single qts">
            <p class="subtitle">单选题
              <em>({{singleScore}}分/题)</em>
            </p>
            <div class="box" >
              <span :class="[current.id==v.topic_uuid?'current':'', v.done===true?'done':'']" v-for="(v,i) in single" :key="i" @click="chooseQts(single,i)" >{{i+1}}</span>
            </div>
          </div>
          <div class="multiple qts">
            <p class="subtitle">多选题
              <em>({{multipleScore}}分/题)</em>
            </p>
            <div class="box" >
                <span :class="[current.id==v.topic_uuid?'current':'', v.done===true?'done':'']" v-for="(v,i) in multiple" :key="i" @click="chooseQts(multiple,i)" >{{i+1}}</span>
              </div>
          </div>
          <div class="judge qts">
            <p class="subtitle">判断题
              <em>({{judgeScore}}分/题)</em>
            </p>
              <div class="box">
                <span :class="[current.id==v.topic_uuid?'current':'', v.done===true?'done':'']" v-for="(v,i) in judge" :key="i" @click="chooseQts(judge,i)">{{i+1}}</span>
              </div>
          </div>
          <button class="submit" @click="toSubmit()">交卷</button>
        </div>
      </div>

    </div>

    <el-dialog
      title="确定是否交卷"
      :visible="layerShow"
      :before-close="handleClose">
    
      <div class="frame">
        <p>用时
          <span class="time">{{time.h}}
            小时{{time.m}}
            分钟{{time.s}}
            秒
          </span>,
          已答<span style="color:#01c26f">{{answer.done}}</span>题,
          未答<span style="color:red">{{answer.not_done}}</span>题
        </p>
        <button class="submit" @click="comfirmSubmit()" style="">确定交卷</button>
        <button class="continue" @click="layerShow=false" style="">继续做题</button>


      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "exam",
  data() {
    return {
      tabShow:true,
     
      allQts:{},
      single:[],
      multiple:[],
      judge:[],

      current:{
        name:'',
        itme:[],
        index:'',
        id:'',
        type:'',
        done:false,
        score:''
      },
      collects:[],  // 所有题目的汇集

      singleScore:'',
      multipleScore:'',
      judgeScore:'',

      timestamp0:'',
      timestamp1:'',
      time:{
        h:'',
        m:'',
        s:''
      },
      answer:{
        done:0,
        not_done:0
      },
      layerShow:false,

      answerCollects:{  // 要提交的答案 
        exam_uuid:'',
        token:'',
        answers:{}
      },

      timeOut:false
    }
  },
  mounted(){
    // 禁用f1--f12 
    this.addListener()


    // 刷新提示
    document.body.onbeforeunload = function(){
      window.event.returnValue = '您即将离开本页面,确定继续吗? 您的考试记录不会被保存，请慎重操作！';
    }
    
    fobidden_back()
    //禁用浏览器返回
      function fobidden_back() {
          //防止页面后退
          history.pushState(null, null, document.URL);
          window.addEventListener('popstate',back_common)
      }
      //启用浏览器返回
      function enable_back() {
          history.go(-1);
          window.removeEventListener('popstate',back_common)
      }
      function back_common() {
          history.pushState(null, null, document.URL);
      }




    this.secondKillTimer(); // 启动倒计时 
    this.timestamp0 = Date.parse(new Date());

    var token=sessionStorage.getItem('token')
    var exam_uuid=sessionStorage.getItem('exam_uuid')

    this.$http.post(this.baseURL+`/api/exam_paper/index?exam_uuid=${exam_uuid}&token=`+token,{token})
    // this.$http.post('http://exam.ah1d.com/api/exam_paper/test')
    // this.$http.get('http://localhost:3000/exam')
    .then((res)=>{
        // console.log(res);
          if(res.data.code ===1){
            this.answerCollects.exam_uuid=res.data.data.exam_uuid;
            this.answerCollects.token=sessionStorage.getItem('token')


            this.single=res.data.data.paper_topic[0].type_1; // 先分类
            this.multiple=res.data.data.paper_topic[0].type_3;
            this.judge=res.data.data.paper_topic[0].type_2;
            this.collects=[...this.single,...this.multiple,...this.judge]  // 再汇集
            
            // console.log(this.single);
            // console.log(this.multiple);
            // console.log(this.judge);
            // console.log(this.collects);

                  // 初始化当前要展示的题 
            this.current.name=this.single[0].name.replace(/&lt;|p&gt;|\/p&gt;|\<|\>|p|\/p/g,'');
            this.current.itme=this.single[0].itme;
            // this.current.itme.forEach((v,i)=>{
            //   v.select=false
            // })
            this.current.type=this.single[0].type; 
            this.current.index=0;
            this.current.id=this.single[0].topic_uuid;

            // 初始化 分数 
            this.singleScore=this.single.length && this.single[0].score || '--';
            this.multipleScore=this.multiple.length && this.multiple[0].score || '--';
            this.judgeScore=this.judge.length && this.judge[0].score || '--';
          }else{
            // alert('没有试题数据')
            alert(res.data.msg)
            this.$router.replace('/home')
          }

    }).catch(err=>{
      console.log(err);
      alert('数据请求失败，建议您重新登录')
    })

  },
  methods:{
    moni(refName){
      // console.log( this.$refs[refName][0]);
      this.$refs[refName][0].click()
    },
          // 禁止倒退 
    RunOnBeforeUnload() {window.onbeforeunload = function(){ return ""; } },
    
    secondKillTimer(){
      var SECOND_KILL_TIME_SCOPE=sessionStorage.getItem('timeDiff');
      // SECOND_KILL_TIME_SCOPE=0.005;
      var time0 = Math.floor(Date.now()/1000) + SECOND_KILL_TIME_SCOPE * 60 *60;
      var spans = document.querySelectorAll('.time span');

      var h1 = Math.floor(SECOND_KILL_TIME_SCOPE/10);
      var h2 = SECOND_KILL_TIME_SCOPE%10;
      spans[0].innerHTML = h1;
      spans[1].innerHTML = h2;
      spans[3].innerHTML = 0;
      spans[4].innerHTML = 0;
      spans[6].innerHTML = 0;
      spans[7].innerHTML = 0;

      var timer = setInterval(()=>{
          var time1 = Math.floor(Date.now()/1000);
          var time = time0 - time1;

          var h = Math.floor(time/3600);
          var m = Math.floor(time%3600/60);
          var s = Math.floor(time%60);

          var h1 = Math.floor(h/10);
          var h2 = h%10;
          var m1 = Math.floor(m/10);
          var m2 = m%10;
          var s1 = Math.floor(s/10);
          var s2 = s%10;

          spans[0].innerHTML = h1;
          spans[1].innerHTML = h2;
          spans[3].innerHTML = m1;
          spans[4].innerHTML = m2;
          spans[6].innerHTML = s1;
          spans[7].innerHTML = s2;

          // console.log(time);
          if(time <= 0){
            console.log(this);
            this.timeOut=true
              clearInterval(timer);
          }
        }, 1000);
    },


    moni(refName){
      // console.log( this.$refs[refName][0]);
      this.$refs[refName][0].click()
    },
        // ============= 重点 =========== done属性(题) 和 select属性（选项） 
    select(itme){
      console.log(itme);
      if(this.current.type===1 || this.current.type===2){ // 单选题 或者 选择题 
        // console.log('单选题');
        var tmpItme = this.current.itme.map((v, i) => {
          var tmpElem = document.getElementById(v.id);
          tmpElem.checked = false;
          v.select = itme.id == v.id;  // 给题的选项添加select标记 
          if (v.select) {
            tmpElem.checked = true;
          }
          return v;
        });
        this.current.itme = tmpItme; // 储存当前答题的结果 

      }else if(this.current.type===3){
        // console.log('多选题');
        
      }

          // 标记每道题是否已答 
      this.collects.forEach((question,i)=>{
        var done=question.itme.some((option,i)=>{
          return option.select===true  // 根据select属性 
        })
        question.done=done;
      })
      // console.log(this.collects);
    },

    chooseQts(qts,i){  // 在tab面板根据序号选择 ---> 更新 current 
     this.current.name=qts[i].name
      // this.current.name=qts[i].name.replace(/&lt;p&gt;|&lt;\/p&gt;|\<p\>|\<\/p\>>/g,'');
      this.current.itme=qts[i].itme;
      this.current.type=qts[i].type;
      this.current.index=i;           // index属性 
      this.current.id=qts[i].topic_uuid;
      this.current.score=qts[i].score;
      // console.log(this.current.id,);
      // console.log(this.current.score);

      switch(this.current.type){
        case 1:
          this.singleScore=this.current.score
          break
        case 2:
          this.judgeScore=this.current.score
          break
        case 3:
           this.multipleScore=this.current.score
          break
      }
    },

    next(id){   // 点击下一题  ---> 更新 current 
      // console.log(id);
      this.collects.forEach((v,i)=>{
        if(v.topic_uuid==id){
          if(i!=this.collects.length-1){
            this.current.name=this.collects[i+1].name.trim()
            // this.current.name=this.collects[i+1].name.replace(/&lt;p&gt;|&lt;\/p&gt;|\<p\>|\<\/p\>>/g,'');
            this.current.itme=this.collects[i+1].itme;
            this.current.type=this.collects[i+1].type;
            this.current.id=this.collects[i+1].topic_uuid;
            this.current.score=this.collects[i+1].score;
            this.current.index+=1;
          }else{
            this.current.name=this.collects[0].name.trim()
            // this.current.name=this.collects[0].name.replace(/&lt;p&gt;|&lt;\/p&gt;|\<p\>|\<\/p\>>/g,'');
            this.current.itme=this.collects[0].itme;
            this.current.type=this.collects[0].type;
            this.current.id=this.collects[0].topic_uuid;
             this.current.score=this.collects[0].score;
            this.current.index=0;
          }
        }

        switch(this.current.type){
          case 1:
            this.singleScore=this.current.score
            break
          case 2:
            this.judgeScore=this.current.score
            break
          case 3:
            this.multipleScore=this.current.score
            break
        }

        var done=v.itme.some((v,i)=>{
          return v.select===true  // 根据select属性 
        })
        v.done=done;  // 标记每道题是否已做 
      })
    },


    toSubmit(){
      this.collects.forEach((v,i)=>{
        var done=v.itme.some((v,i)=>{
          // console.log(v.select);
          return v.select===true
        })
        // console.log(done);
        v.done=done;  // 标记是否已做  
      })


      this.layerShow=true


          // 计算所用时间 
      this.timestamp1=Date.parse(new Date())
      var time=(this.timestamp1-this.timestamp0)/1000
      this.answerCollects['timeUsage']=time  // 后端必须参数？
      this.time.h = Math.floor(time/3600);
      this.time.m = Math.floor(time%3600/60);
      this.time.s = Math.floor(time%60);

      

          // 收录考试答案：把collects数组的数据提炼到 answerCollects对象  
      this.collects.forEach((v)=>{
        var info=[];
        this.answerCollects.answers[v.exam_topic_uuid]=info;  // exam_topic_uuid--> 每道题的id ;  topic_option_uuid--->每道题的每个选项的id 
        v.itme.forEach((v)=>{
          if(v.select){  // 判断是否勾选，用select属性 ---> 关键 
            info.push(v.topic_option_uuid)
          }
        })
      })
      // console.log(this.answerCollects);


        // 计算提交答案的数量：已做  未做 
      var that=this
      function count(o){
        var total= 0,done=0,not_done=0;
        for(var i in o){
          if(o[i].length>0){
            done++
          }else{
            not_done++
          }
          total++;
        }
        that.answer.done=done
        that.answer.not_done=not_done
        // console.log(that.answer);
        // return {total,done,not_done};
      }
      count(this.answerCollects.answers)
      
    },
    comfirmSubmit(){
      this.collects.forEach((v)=>{
        var info=[];
        this.answerCollects.answers[v.exam_topic_uuid]=info;  // exam_topic_uuid--> 每道题的id ;  topic_option_uuid--->每道题的每个选项的id 
        v.itme.forEach((v)=>{
          if(v.select){  // 判断是否勾选，用select属性 ---> 关键 
            info.push(v.topic_option_uuid)
          }
        })
      })
      // console.log(this.answerCollects);

        this.$http.post(this.baseURL+`/api/answer_post/index`,{
          ...this.answerCollects
        })
        .then((res)=>{
          // console.log(res);
            if(res.data.code===1){
              this.$router.push('/over')
            }else{
              alert(res.data.msg)
            }
        })
        .catch((err)=>{
          console.log(err);
          alert('网络出现错误')
        })

    },


        // // 禁用f1--f12 
    listenerHandle(e){
      window.event? window.event.cancelBubble = true : e.stopPropagation();
      // console.log(e);
      // console.log(e.keyCode);
      if(e.keyCode>111 && e.keyCode<124){
        // console.log('---');
        // try{
        //   e.keycode=0
        // }catch(e){}
        e.returnValue=false
      }else{
        // e.preventDefault()
      }
    },
    addListener(){   // 禁用f1--f12 
      document.addEventListener('keydown',this.listenerHandle,false)
    },
  
    
    handleClose(done) {  // 关闭弹层 
       this.layerShow = false;
    }
  },
  
  watch:{
    timeOut(val,oldVal){
      console.log(val,oldVal);
      if(val){
        alert('时间已到，自动交卷！')
        this.answerCollects['timeUsage']=sessionStorage.getItem('timeDiff')*60*60
        this.comfirmSubmit()
      }
    }
  }
}
</script>

<style lang="scss">


.frame button.submit{
  background:#4f93fe;border-radius:20px;width:8rem;height:2.4rem;color:#fff;font-size:15px;border:none;outline:none;
}
.frame button.continue{
  background:#666;border-radius:20px;width:8rem;height:2.4rem;color:#fff;font-size:15px;border:none;outline:none;
  border: 1px solid white;
}


//---------------------------------------------------

#exam{
  width: 63%;
  margin: 0 auto;
  background: #f4f4f4;
}
.timeKiller{
  width: 100%;
  height: 3.68rem;
  top: 0;
  // border: 1px solid red;
  text-align: center;
  line-height: 3.68rem;
  background: #fff;
  font-size: 1.1rem;
  & img{
    width: 2.5rem;
    height: 2.5rem;
  }
  & span{
    color: #999;
    & span{
      color: #f46b65;
      font-weight: 500;
    }
  }
}

.main{
  background: #fff;
  margin-top: 2rem;
  overflow: hidden;
  background: #f4f4f4;
  width: 100%;
  height: 48.8rem;
  
}

.main .show_wrap{
  padding-top:2rem;
  padding-left:2rem;
  padding-right: .5rem;
  // width:55.8rem;
  width: 74%;
  height:100%;
  overflow: hidden;
  float: left;
   background: #fff;
}
.main .qtsTab_wrap{
  // width:18.2rem;
  width: 24%;
  height: 100%;
  overflow: hidden;
  float: right;
}

.qtShow{
  font-size: 1.4rem;
  height: 100%;
  overflow: auto;
  p.qts{
    background: transparent;
  }
}
.qtShow .options{
  // background:pink;
    vertical-align: middle;
    vertical-align: baseline;
    vertical-align:top;
    // height: 2.4rem;
    // line-height: 2.4rem;
    margin-top: 2rem;
    &:hover{
      cursor: pointer;
    }
}
.qtShow .options p{
  // border: 1px solid red;
  vertical-align:top;
  vertical-align:text-top;
  padding-left:2rem;
  user-select: none;
}

.qtShow .options p input{
    display: none;
}
.qtShow .options p label {
    border: 1px solid #999;
    display: inline-block;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 2rem;
    margin-left: -2rem;
}

.qtShow .options p input:checked+label {
    background: url("/image/d4.png") no-repeat 0 0;
    background-size: 1.65rem 1.65rem;
    background-position: -.15rem 0rem;
    width: 1.65rem;
    height: 1.65rem;
}


.qtShow button{
  width: 15.8rem;
  height: 3rem;
  background: #fff;
  border: 1px solid #01c26f;
  color: #01c26f;
  margin-left: 50%;
  transform: translateX(-50%);
  margin-top: 5rem;
  font-size: 1.6rem;
  -moz-user-select: none;
  user-select: none;
  outline: none;
  border-radius: .3rem;
}

.iconShow{
  width:3rem;
  height:3rem;
  color:coral;
  font-size:3rem;
  position:absolute;
  right:0;
  top:23rem;
}


/* ----------------------------------------------------------------------------- */

.qtsTab{
  height: 100%;
  background: #fff;
  padding: 1rem;
  overflow: auto;
}
.qtsTab .done{
  background:#01c26f;
}
.qtsTab span.current{
  background: #4f93fe;
}

.categery{
  height: 2rem;
  justify-content: space-between;
  line-height: 2rem;
  font-size: 1rem;
  margin-top: 1rem;
}
.categery>div{
  display: inline-block;
  width: 33.3%;
  height: 2.5rem;
  vertical-align: middle;
}
.categery>div span{
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  border:1px solid #ccc;
  vertical-align: middle;
  margin-right: .3rem;
}
.categery span.current{
  background: #4f93fe;
}
.categery span.done{
  background: #01c26f;
}


.subtitle{
  border-bottom:1px dashed #888;
  height: 3.5rem;
  line-height: 3.5rem;
  font-size: 1.2rem;
}
em{
  font-style: normal;
  font-size: 1.0rem;
  color: #a0a0a0;
}
.qtsTab .qts{
  margin-top: 2rem;
}
.qtsTab .qts .box{
  padding-top: .5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  // justify-content: flex-start;
  text-align: justify;
}
.qtsTab .qts .box span{
  border:1px solid #ccc;
  width:3.2rem;
  height:3.2rem;
  line-height: 2.1rem;
  text-align: center;
  margin-top: .7rem;
  padding: .6rem;
  user-select: none;
  font-size: 1.35rem;
}


//  --加上after伪类，解决最后一排数量不够两端分布的情况--------------
  .qtsTab .qts .box:after{
    content: '';
    width: 50%;
    border:1px solid transparent;
  }
  .qtsTab .qts .box span{
    width:22%;
    // border:1px solid #ff6600;
    // margin-bottom: 10px;
    display: flex;
    justify-content: center;
  }
// ---------------------------------------------------

.qts span:hover{
  cursor: pointer;
}

.qtsTab button{
  width: 100%;
  height: 3rem;
  margin: 0;
  margin-top: 3.2rem;
  background: #4f93fe;
  color: #fff;
  font-size: 1rem;
  user-select: none;
  outline: none;
  border: none;
  border-radius: .3rem;
}
.qtsTab button:hover{
  cursor: pointer;
}

/* ----------------------------------------------------------------------------- */

.layer{
  position: absolute;
  z-index: 200;
  width: 100%;
  height: 100%;
  background:rgba(0,0,0,.4);
  border: 1px solid #ccc;
}
.layer .frame{
  position: absolute;
  width: 35%;
  height: 250px;
  background: #fff;
  border: 1px solid #ccc;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%)
}
button{
  margin: 20px;
}
.iconShow{
  display: none;
}

/* ----------------------------------------------------------------------------- */

/* max-width 760 */
@media only screen and (max-width:760px){
  .iconShow{
    display: inline-block;
  }
  #exam{
    min-width: 100%;
    height: 100%;
    margin: 0;
  }
  .timeKiller{
    position: fixed;
    height: 8.68rem;
    line-height: 10rem;
    font-size: 4.5rem;
  }
  .timeKiller img{
    width: 8.5rem;
    height: 7.5rem;
  }
  .main{
    margin-top: 10rem;
    /* height: calc(100%-2rem); */
    height: 100%;
    /* padding: 4%; */
    background:#eee;
    
  }
  .main .show_wrap{
    width: 100%;
    height: 60%;
    overflow: scroll;
    // padding: 1rem;
    padding: 0;
  }
  em{
    font-size: 4rem;
  }


  table .char {
    display: inline-block;
    width: 3.5rem;
    height: 8.5rem;
    vertical-align: text-top;
    font-size: 4.5rem;
  }

  .iconShow{
    width: 29rem;
    height: 29rem;
    color: coral;
    font-size: 15rem;
    position: fixed;
    right: -12rem;
    top: 80rem;
  }


  .main .qtsTab_wrap {
      width: 100%;
  }

  .num input:checked+label {
    // background-color: #01c26f;
    // background-image: url('/image/d1.png');
    // background-image: url('../assets/d1.png');
    background: url(/image/d4.png) no-repeat 0 0;
    background-size: 6.2rem 6.2rem;
    background-position: -.5rem 0rem;
    width: 6.2rem;
    height: 6.2rem;
}
.num label {
    background-color:transparent;
    //  background-image: url('../assets/d1.png');
    border: 1px solid #999;
    display: inline-block;
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 2rem;
}

 
  .qtShow{
    display: block;
    width: 100%;
    font-size:6rem;
    background: #eee;
  }
  .qtShow .options p{
    padding-left: 8rem;
    margin-top: 6.5rem;
  }
  .qtShow .options p label{
    width: 6.2rem;
    height: 6.2rem;
    border-radius: 4rem;
    margin-left: -8rem;
  }
  .qtShow .options p input:checked + label {
    background: url(/image/d4.png) no-repeat 0 0;
    background-size: 6.2rem 6.2rem;
    background-position: -.8rem 0rem;
    width: 6.2rem;
    height: 6.2rem;
}

  .qtShow button{
    margin-top: 2rem;
    margin-top:9rem;
    margin-left: 50%;
    transform: translateX(-50%);
  }
  .qtsTab{
    display: block;
    // border:1px solid orange;
    background: #fff;
    width:100%;
    height: 50%;
    margin-top: 2rem;
    position: fixed;
    z-index: 100;
    bottom: 1rem;
    left: 0;
  }
  .qtsTab button {
    width: 60%;
    height: 11rem;
    margin-left: 50%;
    transform: translateX(-50%);
    margin-top: 2.2rem;
    margin-bottom: 5.2rem;
    background: #4f93fe;
    color: #fff;
    font-size: 6rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    outline: none;
    border: none;
    border-radius: 1.3rem;
  }
  .subtitle {
    border-bottom: 1px dashed #888;
    height: 7.5rem;
    line-height: 7.5rem;
    font-size: 4.2rem;
  }
  .qtsTab .qts .box span{
    width: 9.1rem;
    height: 9.1rem;
    line-height: 9.1rem;
    margin: 2.6rem;
    font-size: 5.8rem;
  }

  .categery {
    height: 8rem;
    justify-content: space-around;
    line-height: 5rem;
    font-size: 3rem;
    margin-top: 0rem;
  }
  .categery > div span{
    width: 4.5rem;
    height: 4.5rem;
  }

  .layer .frame{
    width: 100%;
  }

  .num label{
    width: 6rem;
    height: 6rem;
    border-radius: 3rem;
  }
  table,thead,tbody,th,tr,td{
    font-size: 4rem;
  }
  .qtShow button{
    width: 42.8rem;
    height: 12rem;
    font-size: 6rem;
    border-radius: 1.8rem;
    margin-bottom: 50rem;
  }

  .el-dialog__wrapper .frame button{
    width: 28rem;
    height: 10.4rem;
  }


  
}
</style>